// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2BBKi","inputDescription":"styles_inputDescription__2O42f"};